import { render, staticRenderFns } from "./transferguide.vue?vue&type=template&id=67b02534&scoped=true&"
import script from "./transferguide.vue?vue&type=script&lang=js&"
export * from "./transferguide.vue?vue&type=script&lang=js&"
import style0 from "./transferguide.vue?vue&type=style&index=0&id=67b02534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b02534",
  null
  
)

export default component.exports